import { isIgnoredOpgavekompleksetInputNode } from './_inputs.js';

/**
 * determines if a task has at least one actual inputs. Nodes such as text and
 * html, which may be present in the content array, is filtered out, before
 * checking if any inputs exist.
 */
function hasOpgavekompleksetTaskInputs(task) {
  if (!task) {
    return false;
  }
  const content = task.type === "stack" ? task.tasks.flatMap(it => it.content) : task.content;
  return content.filter(it => !isIgnoredOpgavekompleksetInputNode(it)).length > 0;
}

export { hasOpgavekompleksetTaskInputs };
//# sourceMappingURL=util.has-inputs.js.map
